var map = {
	"./Betting.js": "yDOB",
	"./CustomerService.js": "dkDB",
	"./Deposit.js": "ckeI",
	"./Discount.js": "PUjV",
	"./Ipl.js": "tm8S",
	"./Match.js": "xvty",
	"./My.js": "Nu1V",
	"./Team.js": "F9do"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RahM";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build902/router/module \.js$
// module id = RahM
// module chunks = 23